import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _68c36a66 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _5e4a0285 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _f5f526b0 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _487baf14 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _09c135d4 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _78f84ba0 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _747bcc5e = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _f203b48e = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _0d5408fc = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _3e0985ba = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _7a73c3b7 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _4f85cc8e = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _32554716 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _b0886de4 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _0d9d7d79 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _73234a20 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _6f9c7256 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _9cc82976 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _9a418ab6 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _4ce48e00 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _2c5215dc = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _6f78fce0 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _3b5632dd = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _131a8f3a = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _79e2cebc = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _7c0aba5e = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _6331c03c = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _185d1a2c = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _9d13df3a = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _0470e36c = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _52f6babf = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _226f6012 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _5ff0100e = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _9d9eab6a = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _3da386b4 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _8cd3c2d0 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _27b9ca26 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _096aadec = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _152c370a = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _b718ddd4 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _5e94a62e = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _0a83dc64 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _25348d32 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _1af406b3 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _5ecee45d = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _122b32f7 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _2e25ae82 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _c62c20d6 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _fa963648 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _1bb8feb8 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _12e6d08a = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _2352722d = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _1f508140 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _18b6c645 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _bc90d204 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _59d66621 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _72691be4 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _6e25908f = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _4a22c91a = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _151fbc46 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _222260e7 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _1d7037c2 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _ef619ee4 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _282ac716 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _30d67910 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _e1c0b01c = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _bf609604 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _0c5e132c = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _f6857042 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _ce4d93a2 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _2a62537a = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _75da5af1 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _827529b2 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _2cef933e = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _68c36a66,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _5e4a0285,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _f5f526b0,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _487baf14,
    name: "calendar"
  }, {
    path: "/customer",
    component: _09c135d4,
    name: "customer"
  }, {
    path: "/details",
    component: _78f84ba0,
    name: "details"
  }, {
    path: "/goals",
    component: _747bcc5e,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _f203b48e,
    name: "maisoku"
  }, {
    path: "/media",
    component: _0d5408fc,
    name: "media"
  }, {
    path: "/privacy",
    component: _3e0985ba,
    name: "privacy"
  }, {
    path: "/project",
    component: _7a73c3b7,
    name: "project"
  }, {
    path: "/response",
    component: _4f85cc8e,
    name: "response"
  }, {
    path: "/achievement/output",
    component: _32554716,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _b0886de4,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _0d9d7d79,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _73234a20,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _6f9c7256,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _9cc82976,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _9a418ab6,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _4ce48e00,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _2c5215dc,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _6f78fce0,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _3b5632dd,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _131a8f3a,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _79e2cebc,
    name: "response-registration"
  }, {
    path: "/setting/announcement",
    component: _7c0aba5e,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _6331c03c,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _185d1a2c,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _9d13df3a,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _0470e36c,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _52f6babf,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _226f6012,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _5ff0100e,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _9d9eab6a,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _3da386b4,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _8cd3c2d0,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _27b9ca26,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _096aadec,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _152c370a,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _b718ddd4,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _5e94a62e,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _0a83dc64,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _25348d32,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _1af406b3,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _5ecee45d,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _122b32f7,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _2e25ae82,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _c62c20d6,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _fa963648,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _1bb8feb8,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _12e6d08a,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _2352722d,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _1f508140,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _18b6c645,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _bc90d204,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _59d66621,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _72691be4,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _6e25908f,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _4a22c91a,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _151fbc46,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _222260e7,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _1d7037c2,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _ef619ee4,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _282ac716,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _30d67910,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _e1c0b01c,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _bf609604,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _0c5e132c,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _f6857042,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _ce4d93a2,
    name: "property-property",
    children: [{
      path: "contact",
      component: _2a62537a,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _75da5af1,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _827529b2,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _2cef933e,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
